__turbopack_context__.v({
  "clientEntry": "ClientEntry-module__XLlp0G__clientEntry",
  "clientEntry__content": "ClientEntry-module__XLlp0G__clientEntry__content",
  "clientEntry__icon": "ClientEntry-module__XLlp0G__clientEntry__icon",
});
